import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'embryo-SubscribeTwo',
  templateUrl: './SubscribeTwo.component.html',
  styleUrls: ['./SubscribeTwo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscribeTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
